import { IconButton, IconName } from "@/components/common";
import { RequireOnlyOne } from "@/interfaces/common";
import { ComponentProps } from "react";
import { To } from "react-router-dom";

type Props = Readonly<
  Omit<ComponentProps<typeof IconButton>, "aria-label" | "icon" | "onClick" | "to"> & {
    icon?: IconName;
    onClick?: () => void;
    to?: To;
  }
>;

export const TableView = ({ icon = "KeyboardArrowRight", ...props }: RequireOnlyOne<Props, "onClick" | "to">) => {
  return <IconButton {...props} icon={icon} aria-label="Visualizar" />;
};
